export default "__VITE_PUBLIC_ASSET__b6d8bfad__"